import { cookies } from './cookies';

export const notice = () => {

    const body = document.body;

    /* Investor Relations class to trigger notice */
    const noticeInvestorRelations = document.querySelector('.investor-relations');

    /* Country elements */
    const noticeCountry = document.querySelector('#notice-country');
    const noticeCountryError = document.querySelector('#notice-country-error');

    /* Investor Type elements */
    const noticeInvestorType = document.querySelector('#notice-investor-type');
    const noticeInvestorTypeActions = document.querySelector('#notice-investor-type-actions');

    /* Annex 1 elements */
    const noticeAnnex1 = document.querySelector('#notice-annex-1');
    const noticeAnnex1Actions = document.querySelector('#notice-annex-1-actions');
    const noticeAnnex1Submit = document.querySelector('#notice-annex-1-submit');
    const noticeAnnex1NoThanks = document.querySelector('#notice-annex-1-no-thanks');
    const noticeForm = document.querySelector('#notice__form');
    const noticeContent = document.querySelector('#notice__content');
    const noticeAnnex1Checkbox = document.querySelector('#notice-annex-1-checkbox');
    const noticeAnnex1Error = document.querySelector('#notice-annex-1-checkbox-error');

    if (noticeInvestorRelations) {
        noticeInvestorRelations.addEventListener('click', (e) => {
            e.preventDefault();
            /* Delete notice cookie */
            cookies.deleteCookie('STYXKEY_notice');
            /* Open notice */
            body.classList.add('notice--is-open');
            document.documentElement.classList.add('notice--is-open');
        });
    }

    /* Country select */
    if (noticeCountry) {

        const countriesList = Object.keys(window.noticeVars.countries);
        noticeCountry.insertAdjacentHTML(
            'beforeend',
            countriesList.map(country => `<option value="${country}">${country}</option>`).join('')
        );

        noticeCountry.addEventListener('change', () => {

            if (noticeInvestorType && noticeInvestorType.parentElement) {
                noticeInvestorType.parentElement.classList.add('is-hidden');
            }

            let noticeCountryValue = noticeCountry.value;

            if (window.noticeVars.countries[noticeCountryValue].redirect) {
                cookies.deleteCookie('STYXKEY_notice');
                cookies.setCookie('STYXKEY_notice', noticeCountryValue + '|redirect', 1);


                if ( typeof window.noticeVars.countries[noticeCountryValue].redirect === 'object' ) {
                    let redirect = window.noticeVars.countries[noticeCountryValue].redirect;
                    let redirectUrl = redirect.url;
                    let redirectText = redirect.text;
                    noticeCountryError.innerHTML = redirectText;
                    noticeCountryError.classList.add('is-loading');
                    noticeCountry.setAttribute('disabled', 'disabled');

                    setTimeout(() => {
                        window.location.href = redirectUrl;
                    }, 3000);

                } else {
                    window.location.href = window.noticeVars.countries[noticeCountryValue].redirect;
                }
                return;
            }

            const noticeCountryOptions = Object.keys(window.noticeVars.countries[noticeCountryValue].options);

            if (noticeInvestorType) {
                noticeInvestorType.innerHTML = '';
                noticeInvestorType.insertAdjacentHTML(
                    'beforeend',
                    `<option value="">Select investor type</option>`
                );
                noticeInvestorType.insertAdjacentHTML(
                    'beforeend',
                    Object.keys(window.noticeVars.countries[noticeCountry.value].options).map(investorType => `<option value="${investorType}">${investorType}</option>`).join('')
                );
            }

            if (noticeInvestorTypeActions) {
                noticeInvestorTypeActions.innerHTML = '';
            }

            if (noticeAnnex1) {
                noticeAnnex1.classList.add('is-hidden');
            }

            if (noticeCountryValue && noticeInvestorType && noticeInvestorType.parentElement) {
                noticeInvestorType.parentElement.classList.remove('is-hidden');
            }


        });

        // if (noticeInvestorType) {
        //     noticeInvestorType.addEventListener('change', (e) => {
        //         e.preventDefault();

        //         let noticeInvestorTypeValue = noticeInvestorType.value;
        //         let noticeInvestorTypeOptions = window.noticeVars.countries[noticeCountry.value].options[noticeInvestorTypeValue];
        //         let noticeInvestorTypeActions = document.querySelector('#notice-investor-type-actions');

        //     console.log(noticeInvestorType.value);
        //     console.log(window.noticeVars.countries[noticeCountry.value].options[noticeInvestorType.value]);

        //     if (noticeInvestorTypeOptions.buttons !== undefined) {
        //         if (noticeActions) {
        //             noticeActions.classList.remove('is-hidden');
        //         }

        //         if (noticeInvestorTypeActions) {
        //             noticeInvestorTypeActions.innerHTML = '';
        //             noticeInvestorTypeActions.insertAdjacentHTML(
        //                 'beforeend',
        //                 `<button data-link="${noticeInvestorTypeOptions.buttons.confirm.link}">${noticeInvestorTypeOptions.buttons.confirm.text}</button>`
        //             );
        //             noticeInvestorTypeActions.insertAdjacentHTML(
        //                 'beforeend',
        //                 `<button data-link="${noticeInvestorTypeOptions.buttons.deny.link}">${noticeInvestorTypeOptions.buttons.deny.text}</button>`
        //             );
        //             noticeInvestorTypeActions.addEventListener('click', (e) => {
        //                 e.preventDefault();
        //                 let noticeInvestorTypeActionLink = e.target.dataset.link;
        //                 cookies.deleteCookie('STYXKEY_notice');
        //                 cookies.setCookie('STYXKEY_notice', noticeCountry.value + '|' + noticeInvestorType.value + '|' + e.target.dataset.action, 30);
        //                 window.location.href = noticeInvestorTypeActionLink;
        //             });
        //             noticeInvestorTypeActions.classList.remove('is-hidden');
        //         }
        //     } else if (noticeInvestorTypeOptions.redirect !== undefined) {
        //         cookies.deleteCookie('STYXKEY_notice');
        //         cookies.setCookie('STYXKEY_notice', noticeCountry.value + '|' + noticeInvestorType.value + '|redirect', 30);
        //         window.location.href = noticeInvestorTypeOptions.redirect;
        //         if (noticeActions) {
        //             noticeActions.classList.add('is-hidden');
        //         }
        //     }
        //     });
        // }

    }

    /* Investor Type select */
    if (noticeInvestorType) {
        noticeInvestorType.addEventListener('change', () => {

            let investorType = window.noticeVars.countries[noticeCountry.value].options[noticeInvestorType.value];

            console.log('investorType', investorType);

            // Check if investorType exists
            if (!investorType) {
                console.error('Investor type not found:', noticeInvestorType.value);
                return;
            }

            let investorText = investorType.text;
            let investorButtons = investorType.buttons;
            let investorRedirect = investorType.redirect;

            // Handle redirect case
            if (investorRedirect) {
                console.log('redirect', investorRedirect);
                cookies.deleteCookie('STYXKEY_notice');
                cookies.setCookie('STYXKEY_notice', noticeCountry.value + '|' + noticeInvestorType.value + '|' + investorRedirect + '|redirect', 1);
                window.location.href = investorRedirect;
                return;
            }

            // Handle buttons case
            if (investorButtons && investorButtons.confirm && investorButtons.deny) {
                let investorConfirm = investorButtons.confirm;
                let investorDeny = investorButtons.deny;
                let investorConfirmLink = investorConfirm.link;
                let investorDenyLink = investorDeny.link;
                let investorConfirmText = investorConfirm.text;
                let investorDenyText = investorDeny.text;

                // Populate dynamic links inside noticeInvestorTypeActions
                if (noticeInvestorTypeActions) {
                    noticeInvestorTypeActions.innerHTML = `
                    <p>${investorText || ''}</p>
                    <a href="#" data-action="deny" data-link="${investorDenyLink || '#'}">${investorDenyText || ''}</a>
                    <a href="#" data-action="confirm">${investorConfirmText || ''}</a>
                `;
                    noticeInvestorTypeActions.classList.remove('is-hidden');

                    /* Annex 1 links */
                    if (noticeAnnex1Submit) {
                        noticeAnnex1Submit.setAttribute('href', investorConfirmLink);
                    }
                    if (noticeAnnex1NoThanks) {
                        noticeAnnex1NoThanks.setAttribute('href', investorDenyLink);
                    }

                }
            }

            if (investorType.buttons === undefined) {
                console.error('Invalid investor type structure:', investorType);
                if (noticeAnnex1Actions) {
                    noticeAnnex1Actions.classList.add('is-hidden');
                }
            }
        });
    }

    /* Investor Type actions */
    if (noticeInvestorTypeActions) {
        noticeInvestorTypeActions.addEventListener('click', (e) => {
            e.preventDefault();
            // Check if the clicked element has a data-link attribute
            if (e.target.dataset && e.target.dataset.action) {
                let action = e.target.dataset.action || '';

                if (action == 'confirm') {
                    if (noticeAnnex1 && noticeContent) {
                        noticeAnnex1.classList.remove('is-hidden');

                        // Calculate position relative to the scrolling container (.notice__content)
                        const contentRect = noticeContent.getBoundingClientRect();
                        const annexRect = noticeAnnex1.getBoundingClientRect();
                        noticeContent.scrollTo({
                            top: noticeContent.scrollTop + (annexRect.top - contentRect.top),
                            behavior: 'smooth'
                        });

                    }
                } else {
                    if (noticeAnnex1) {
                        noticeAnnex1.classList.add('is-hidden');
                    }
                    window.location.href = e.target.dataset.link;
                }
            }
        });
    }

    /* Annex 1 submit */
    if (noticeAnnex1Submit) {
        noticeAnnex1Submit.addEventListener('click', (e) => {
            e.preventDefault();

            if (!noticeAnnex1Checkbox || !noticeAnnex1Checkbox.checked) {
                if (noticeAnnex1Error) {
                    noticeAnnex1Error.innerHTML = 'Please check the box to agree to terms and conditions';
                    noticeAnnex1Error.classList.add('error');
                }
                return;
            }

            if (noticeAnnex1Error) {
                noticeAnnex1Error.innerHTML = '';
                noticeAnnex1Error.classList.remove('error');
            }

            cookies.deleteCookie('STYXKEY_notice');
            cookies.setCookie('STYXKEY_notice', noticeCountry.value + '|' + noticeInvestorType.value + '|' + e.currentTarget.getAttribute('href') + '|confirm', 1);
            window.location.href = e.currentTarget.getAttribute('href');
        });
    }

    /* Annex 1 no thanks */
    if (noticeAnnex1NoThanks) {
        noticeAnnex1NoThanks.addEventListener('click', (e) => {
            e.preventDefault();
            cookies.deleteCookie('STYXKEY_notice');
            const noAccessLink = window.noticeVars?.annex_no_access || '/';
            window.location.href = noAccessLink;
        });
    }

    /* Annex 1 checkbox validation */
    if (noticeAnnex1Checkbox && noticeAnnex1Error) {
        noticeAnnex1Checkbox.addEventListener('change', () => {
            if (noticeAnnex1Checkbox.checked) {
                noticeAnnex1Error.innerHTML = '';
                noticeAnnex1Error.classList.remove('error');
            }
        });
    }

};

